
import React, { useEffect, useState } from 'react';
import { SaveTenants, UpdateTenants } from '../../../../services/CommonService';
import '../../../index.css';
import { v4 as uuid } from 'uuid';
import { ToastContainer, toast } from "react-toastify";
import EventBus from '../../../../services/EventBus';
import FileBase64 from 'react-file-base64';

const AddTenant = ({ dataprops }) => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const fields = {
        name: '',
        status: '',
        domain: '',
        type: '',
        tenantid: uuid().slice(0, 8),
        subscriptionallowed: '',
        subscriptionamount: '',
        capturearea: '',
        capturecollege: '',
        offeramount: '',
        capturestate: '',
        tenantemail: '',
        password: '',
        showcourseprice: 'Yes',
        autosubscribe: 'No',
        months: '',
        isacademicsfree: false,
        isstudentprogramfree: false,
        isofflineenrollment: false,
        showdistrict: 'no',
        showcontituencybutton: 'yes',
        singledevice: false,
        androidlink: '',
        ioslink:''


    }

    const errors = {
        name: '',
        status: '',
        domain: '',
        type: '',
        tenantid: '',
        subscriptionallowed: '',
        subscriptionamount: '',
        capturearea: '',
        capturecollege: '',
        offeramount: '',
        capturestate: '',
        tenantemail: '',
        password: '',
        showcourseprice: '',
        autosubscribe: '',
        months: '',
        androidlink: '',
        ioslink:''



    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFormFields] = useState(fields);
    const [checkedOne, setCheckedOne] = useState(false);
    const updateOne = () => setCheckedOne((prev) => !prev);

    const [checkedTwo, setCheckedTwo] = useState(false);
    const updateTwo = () => setCheckedTwo((prev) => !prev);

    const [checkedThree, setCheckedThree] = useState(false);
    const [checkedFour, setCheckedFour] = useState(false);
    const updateThree = () => setCheckedThree((prev) => !prev);


    const updateFour = () => setCheckedFour((prev) => !prev);
    const [filefields, setFileFields] = useState(null);
    const [imageShow, setImageshow] = useState(false);
    const [iosfields,setIosfields]=useState(null);
    const [iosImage,setIosImage]=useState(false)

    useEffect(() => {
        console.log(dataprops);
        setFieldData();

    }, []);


    const { name, status, domain, type, tenantid, subscriptionallowed,
        subscriptionamount, capturearea, capturecollege, offeramount, capturestate, tenantemail, password, showcourseprice,
        autosubscribe, months, isacademicsfree, isstudentprogramfree, showdistrict, showcontituencybutton, androidlink ,ioslink} = formfields;

    const setFieldData = async () => {
        if (dataprops?.id) {

            setFormFields(dataprops);
            setCheckedOne(dataprops.isacademicsfree);
            setCheckedTwo(dataprops.isstudentprogramfree);
            setCheckedThree(dataprops.isofflineenrollment);
            setCheckedFour(dataprops.singledevice);
            setFileFields(dataprops.androidqr);
            setImageshow(true);
            setIosfields(dataprops.iosqr)
            setIosImage(true)
        }
    }

    function handleChangeFile(files) {
        console.log(files);
        setFileFields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setFileFields(files[0].base64);
                //setImageShow(files[0].base64);
                setImageshow(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }

    function handleChangeIOSFile(files) {
        console.log(files);
        setIosfields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setIosfields(files[0].base64);
                //setImageShow(files[0].base64);
                setIosImage(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter tenant name .";
        }
        if (!fields["domain"]) {
            formIsValid = false;
            errors["domain"] = "*Please enter domain name .";
        }
        if (!fields["type"]) {
            formIsValid = false;
            errors["type"] = "*Please select type. ";
        }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status either active or inactive.";
        }
        if (!fields["subscriptionallowed"]) {
            formIsValid = false;
            errors["subscriptionallowed"] = "*Please select subscription allowed.";
        }
        if (!fields["subscriptionamount"]) {
            formIsValid = false;
            errors["subscriptionamount"] = "*Please select subscription amount.";
        }
        if (!fields["offeramount"]) {
            formIsValid = false;
            errors["offeramount"] = "*Please enter offer amount.";
        }
        if (!fields["capturearea"]) {
            formIsValid = false;
            errors["capturearea"] = "*Please select capture constituency.";
        }
        if (!fields["capturecollege"]) {
            formIsValid = false;
            errors["capturecollege"] = "*Please select capture college";
        }
        if (!fields["capturestate"]) {
            formIsValid = false;
            errors["capturestate"] = "*Please select capture state";
        }
        if (!fields["tenantemail"]) {
            formIsValid = false;
            errors["tenantemail"] = "*Please select tenant login email";
        }

        if (!fields["password"] && !dataprops?.id) {
            formIsValid = false;
            errors["password"] = "*Please select tenant login password";
        }
        if (!fields["showcourseprice"]) {
            formIsValid = false;
            errors["showcourseprice"] = "*Please select show course price";
        }
        if (!fields["autosubscribe"]) {
            formIsValid = false;
            errors["autosubscribe"] = "*Please select auto subscribe";
        }
        if (!fields["months"]) {
            formIsValid = false;
            errors["months"] = "*Please enter subscription months for platform";
        }

        if (!fields["androidlink"]) {
            formIsValid = false;
            errors["androidlink"] = "*Please enter androidlink .";
        }

        setErrorFields(errors)
        return formIsValid;

    }

    const submitForm = async () => {
        console.log("form field before",formfields);
        const isValid = await validateForm();
        if (isValid) {
            formfields.isacademicsfree = checkedOne;
            formfields.isstudentprogramfree = checkedTwo;
            formfields.isofflineenrollment = checkedThree;
            formfields.singledevice = checkedFour;
            formfields.androidqr =filefields;
            formfields.iosqr=iosfields;

            if (!formfields.id) {
                //save
                const Response = await SaveTenants(formfields);
                if (Response.data?.id) {
                    notifyTopFullWidth("Tenant saved sucessfully");
                    formfields.id = Response.data.id;
                    formfields.tenantid = Response.data.tenantid
                    EventBus.dispatch("tenantSave", {
                        message: 'Y'
                    });
                } else {
                    notifyTopFullWidth("Failed to save tenant");
                }


            } else {
                //update
                const Response = await UpdateTenants(formfields);
                // const Response = ""
                if (Response.data.id) {
                    notifyTopFullWidth("Tenant updated sucessfully");
                    formfields.id = Response.data.id;
                    EventBus.dispatch("tenantSave", {
                        message: 'Y'
                    });
                } else {
                    notifyTopFullWidth("Failed to update tenant");
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormFields((prevState) => ({
            ...prevState,
            [name]: value,
        }))
    }


    return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Tenant Name
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter tenant name"
                    name="name"
                    className="form-control"

                    value={name} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.name}</div>
        </div>
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Domain
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter domain"
                    name="domain"
                    className="form-control"
                    value={domain} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.domain}</div>
        </div>
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Type
            </label>
            <div className="col-lg-6" >
                <select component="input"
                    name="type"
                    className="form-control"
                    value={type} onChange={handleChange}>
                    <option value="">Select Below</option>
                    <option value="political">Political</option>
                    <option value="educational">Educational</option>
                    <option value="Others">Others</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.type}</div>
        </div>
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Status
            </label>
            <div className="col-lg-6" >

                <select
                    value={status} name='status' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Active">Active</option>
                    <option value="InActive">Inactive</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.status}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Platform Subscription
            </label>
            <div className="col-lg-6" >

                <select
                    value={subscriptionallowed} name='subscriptionallowed' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.subscriptionallowed}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Subscription Amount
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter subscription amount"
                    name="subscriptionamount"
                    className="form-control"
                    value={subscriptionamount} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.subscriptionamount}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Offer Amount
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter offer amount"
                    name="offeramount"
                    className="form-control"
                    value={offeramount} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.offeramount}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Allow Constituency selection during registration ?
            </label>
            <div className="col-lg-6" >

                <select
                    value={capturearea} name='capturearea' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.capturearea}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Allow State selection during registration ?
            </label>
            <div className="col-lg-6" >

                <select
                    value={capturestate} name='capturestate' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.capturearea}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Allow College selection during registration ?
            </label>
            <div className="col-lg-6" >

                <select
                    value={capturecollege} name='capturecollege' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.capturearea}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Tenant Login Email
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter tenant  login email"
                    name="tenantemail"
                    className="form-control"
                    value={tenantemail} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.tenantemail}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Tenant Login Password
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter tenant  login password"
                    name="password"
                    className="form-control"
                    value={password} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.password}</div>
        </div>
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Show course price
            </label>
            <div className="col-lg-6" >

                <select
                    value={showcourseprice} name='showcourseprice' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.showcourseprice}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Auto Subscribe to platform
            </label>
            <div className="col-lg-6" >

                <select
                    value={autosubscribe} name='autosubscribe' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.autosubscribe}</div>
        </div>
        <br />
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Subscription months(Number)
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter subscription months"
                    name="months"
                    className="form-control"
                    value={months} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.months}</div>
        </div>
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Show Districts
            </label>
            <div className="col-lg-6" >

                <select
                    value={showdistrict} name='showdistrict' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.showdistrict}</div>
        </div>
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Show Constituency Button
            </label>
            <div className="col-lg-6" >

                <select
                    value={showcontituencybutton} name='showcontituencybutton' onChange={handleChange} className="form-control">
                    <option value="">Select below</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.showcontituencybutton}</div>
        </div>
        <div className="form-group mb-3 col-md-3">
            <label>Is Academics Acces Free</label>

            <input className="form-check-input" type="checkbox"
                checked={checkedOne} onChange={updateOne} />
        </div>
        <div className="form-group mb-3 col-md-3">
            <label>IS Students Program Free</label>

            <input className="form-check-input" type="checkbox"
                checked={checkedTwo} onChange={updateTwo} />
        </div>
        <div className="form-group mb-3 col-md-3">
            <label>Enable offline enrollment</label>

            <input className="form-check-input" type="checkbox"
                checked={checkedThree} onChange={updateThree} />
        </div>
        <div className="form-group mb-3 col-md-3">
            <label>Single Device Login</label>

            <input className="form-check-input" type="checkbox"
                checked={checkedFour} onChange={updateFour} />
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Android link
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter android link"
                    name="androidlink"
                    className="form-control"
                    value={androidlink} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.androidlink}</div>
        </div>
        

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Android QR Image
            </label>
            <div className="custom-file">
                <FileBase64
                    multiple={true}
                    onDone={handleChangeFile} />
            </div>
            <div className="errorMsg">{errorFields.base64}</div>
        </div>

        <br />
        {imageShow && <> <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Uploaded Android QR 
            </label>
            <img src={filefields} alt="Red dot" />

        </div> </>}
        <br/>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                IOS link
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="enter ios link"
                    name="ioslink"
                    className="form-control"
                    value={ioslink} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.ioslink}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                IOS QR Image
            </label>
            <div className="custom-file">
                <FileBase64
                    multiple={true}
                    onDone={handleChangeIOSFile} />
            </div>
            <div className="errorMsg">{errorFields.base64}</div>
        </div>

        <br />
        {iosImage && <> <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Uploaded IOS QR Image
            </label>
            <img src={iosfields} alt="Red dot" />

        </div> </>}
        <div className="form-group">
            <button onClick={submitForm} className="btn btn-primary" type="button"
            >Save</button>
        </div>

    </>)

}

export default AddTenant